export const MAX_SUPERSTAR_SEARCH_TEXT_LENGTH = 512;
